import React from 'react';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import cn from 'classnames';

export interface WarningBannerProps {
  /**
   * The label for the selectable item
   */
  translatedContent: TranslatedContent;

  /**
   * The left side icon (optional)
   */
  icon: React.FC<SvgProps> | null;

  /**
   * Whether or not it is showing.
   */
  isShowing: boolean;
}

export const WARNING_BANNER_HEIGHT_CLASS = 'h-[37px]';

export const WarningBanner: React.FC<WarningBannerProps> = ({
  icon,
  translatedContent,
  isShowing,
}) => {
  return (
    <div
      className={cn(
        'w-full bg-yellow-100 flex flex-row items-center justify-center gap-2 transition-all',
        {
          'h-[0px]': !isShowing,
          [WARNING_BANNER_HEIGHT_CLASS]: isShowing,
        },
      )}
    >
      {isShowing &&
        icon &&
        icon({
          svg: {
            className: 'w-[1em] h-[1em] text-gray-900',
          },
        })}

      {isShowing && (
        <S2Typography
          translatedContent={translatedContent}
          variant={'body-7'}
          textColorVariant={'gray-900'}
        />
      )}
    </div>
  );
};
